export enum ProcedureFlags {
  FEMALE = "FEMALE",
  MALE = "MALE",
  TRANS = "TRANS",
  // DEPRECATED (Pricing v2, 2026-09): superseded by enabledModifiers
  // (WEIGHT_LOSS_HX) for pricing; visibility-metadata only today.
  MASSIVE_WEIGHT_LOSS = "MASSIVE_WEIGHT_LOSS",
  LIPO_ADDON = "LIPO_ADDON",
  SPECIAL = "SPECIAL",
  LOCAL_ANESTHESIA_ELIGIBLE = "LOCAL_ANESTHESIA_ELIGIBLE",
  // Surfaced as a cross-sell checkbox on the public booking page.
  // See docs/payments/14_BOOKING_LINK_FLOW.md.
  BOOKING_CROSS_SELL = "BOOKING_CROSS_SELL",
  // Suppresses ALL percentage risk-factor modifiers for this procedure's
  // line only — charged at exactly its listed price. Independent of
  // SPECIAL. See DISABLE_PRICE_MODIFIERS_FLAG in
  // server/shared/pricing/pricingConfig.ts.
  DISABLE_PRICE_MODIFIERS = "DISABLE_PRICE_MODIFIERS",
  // Marks a bundled special (e.g. "RED WHITE and RENEW"). In the estimate
  // builder a COMBO line can carry informational sub-procedures that never
  // affect price — see QuoteInvoiceItem.subProcedures.
  COMBO = "COMBO",
  // Display-only flag — surfaces the procedure in the iOS app's Explore top
  // carousel alongside specials. Since PR #1492 it also pins the procedure
  // up-front with a pill in the web quote funnel's select-procedures step.
  // Still display-only — no effect on pricing or quote behavior.
  FEATURED = "FEATURED",
  // Displayed in admin as "AWAKE OPTIONAL" (owner rename 2026-09-09). The
  // STORED value stays NON_SURGICAL — it is a clinical-scope fact driving
  // pre-op scope (MED_HX_ONLY) via server/services/preopScopeService.ts;
  // renaming the stored value would need a schema + data migration for zero
  // behavioral gain. Label derives from this key (key.replace(/_/g, " ")).
  AWAKE_OPTIONAL = "NON_SURGICAL",
}
